//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Display/Display.DynamicSectionBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Annotations/Annotations.HatchFillSettingsBuilder.js";
import "../Annotations/Annotations.CuttingPlaneSymbolBuilder.js";
import "../Annotations/Annotations.PmiSectionViewSettingsBuilder.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AssemblyCrosshatching",1,1],[1,"BoundingBoxComponents",0,"SelectDisplayableObjectList",0],[0,"ClipCoplanarObjects",1,0],[0,"ClipWireframeObjects",1,0],[1,"CrosshatchSettings",0,"Annotations.HatchFillSettingsBuilder",1],[1,"CuttingPlaneSymbol",0,"Annotations.CuttingPlaneSymbolBuilder",1],[0,"DisplayCrosshatch",1,1],[1,"ObjectsToSection",0,"SelectDisplayableObjectList",0],[0,"PatternDefinedBy",1,1],[0,"RestrictCrosshatch",1,1],[0,"SaveAssociativeCurves",1,0],[1,"Settings",0,"Annotations.PmiSectionViewSettingsBuilder",0],[0,"ToleranceCrosshatch",1,1],[0,"ViewName",1,0]],[[["numCurves","curves"],"GetSectionCurves",{},0,0],[["addObjects","bodies"],"AddRemoveObjectsToSection",{},2,0]],[]];
SPLM.Annotations.LightweightSectionBuilder = class extends SPLM.Display.DynamicSectionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.LightweightSectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;